"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

function createSvgIcon(_ref) {
  var as = _ref.as,
      ariaLabel = _ref.ariaLabel,
      displayName = _ref.displayName,
      category = _ref.category;

  var IconComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
      "aria-label": ariaLabel,
      "data-category": category,
      ref: ref,
      as: as
    }, props));
  });

  IconComponent.displayName = displayName;
  return IconComponent;
}

var _default = createSvgIcon;
exports["default"] = _default;
module.exports = exports.default;